<template>
  <fragment>
    <footer class="navbar py-3 px-4" style="border-top: 1px solid #ddd">
      <ul class="list-inline mb-3 mb-md-0 small">
        <li class="list-inline-item mr-5">
          <a :href="redirectUrl.LANDING_PAGE" class="text-secondary"
            >官网首页</a
          >
        </li>
        <li class="list-inline-item mr-5">
          <a :href="redirectUrl.MALL_PAGE" class="text-secondary">品职商城</a>
        </li>
        <li class="list-inline-item mr-5">
          <!-- <a :href="redirectUrl.LEGAL_PAGE" class="text-secondary">学员协议</a> -->
          <a
            href="https://resources.pzacademy.com/legal.html"
            target="_blank"
            class="text-secondary"
            >学员协议</a
          >
        </li>
        <li class="list-inline-item mr-5">
          <!-- <a :href="redirectUrl.PRIVACY_PAGE" class="text-secondary">隐私政策</a> -->
          <a
            href="https://resources.pzacademy.com/privacy.html"
            target="_blank"
            class="text-secondary"
            >隐私政策</a
          >
        </li>
      </ul>
      <p class="text-secondary mb-0 small">
        © 2015-{{ new Date().getFullYear() }} PZ Academy. All Rights Reserved.
      </p>
    </footer>
  </fragment>
</template>

<script>
// import { PORTAL_URLS } from '../constants';
import { REDIRECT_URLS } from '../constants';

export default {
  name: 'Footer',
  data: () => {
    return {
      // portalURL: PORTAL_URLS,
      redirectUrl: {
        ...REDIRECT_URLS,
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
